import Vue from "vue";
import QR from "qrcode";

export default async function query(state, payload) {
  // Get store references from window (needed for nested dispatches)
  const store = window.$store;
  const s = store.state;
  const st = s;
  const { fbBase, fbusersbase } = require('../util').default.fb();
  const [t, f] = [true, false];

  // console.log("query", payload);
  Object.entries(payload).map((prop) => {
    /*
    // STRATEGY 'p__' represents a point in state.
    */
    if (typeof prop[1] === "string" && prop[1].indexOf("p__") === 0) {
      let point = store.state;
      prop[1]
        .split("state.")[1]
        .split(".")
        .forEach((key) => {
          point = !+key ? point[key] : point[+key];
        });
      // Avoid circular references by converting to safe format
      try {
        payload[prop[0]] = JSON.parse(JSON.stringify(point));
      } catch (e) {
        payload[prop[0]] = String(point);
      }
    }
    /**/
  });

  // TODO remove fb call until required
  // Only load refs if not already loaded to prevent unnecessary queries
  if (!store.state.ref || Object.keys(store.state.ref).length === 0) {
    var refObj = {};
    var refArr = ["image", "name", "title"];
    var getRef = function (refType) {
      refObj[refType] = fbBase.collection("ref").doc(refType);
      refObj[refType].get().then((snap) => {
        Vue.set(store.state.ref, refType, snap.exists ? snap.data() : {});
      });
    };

    refArr.forEach((ref) => {
      getRef(ref);
    });
  }

  const methods = {
    reputation: async (payload) => {
      let reppromise = new Promise((resolve) => {
        return fbBase
          .collection(payload.type)
          .doc(payload.id)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const returnReps = doc.data();
              store.state.reputation[payload.id] = store.state.reputation[
                payload.id
              ] || {
                data: {},
                meta: {},
              };
              store.commit("set", {
                keys: ["reputation", payload.id, "data"],
                val: returnReps,
              });

              return fbBase
                .collection(payload.type)
                .doc(payload.id)
                .collection("meta")
                .doc("stats")
                .onSnapshot(
                  {
                    // Listen for document metadata changes
                    includeMetadataChanges: t,
                  },
                  function (doc) {
                    if (doc.exists) {
                      const returnMetaReps = doc.data();
                      store.state.reputation[payload.id] =
                        store.state.reputation[payload.id] || {};
                      store.commit("set", {
                        keys: ["reputation", payload.id, "meta"],
                        val: returnMetaReps,
                      });
                      // Vue.set(store.state.reputation[payload.id], 'meta', returnMetaReps)
                      // mu.increment(store.state)
                      resolve(returnReps);
                    }
                  }
                );
            }
          });
      });
      return reppromise.then((x) => x);
    },
    list: async (payload) => {
      return fbBase
        .collection(payload.collection)
        .limit(payload.limit || 100)
        .get()
        .then((docs) => {
          st.items[payload.collection] = {};
          docs.docs.map(async (doc) => {
            var docData = doc.data();
            // todo, remove all timestamps with a general admin function created instead of timestamps upkeep
            docData.created = docData.created || docData.timestamps[0];
            docData.basics.published ||
            docData.user == store.state.auth.uid ||
            store.state.app.user.includes(store.state.auth.uid) ||
            (store.state.app.advanced.roles.admin &&
              store.state.app.advanced.roles.admin.members &&
              store.state.app.advanced.roles.admin.members.includes(
                store.state.auth.uid
              ))
              ? Vue.set(
                  store.state.items[payload.collection],
                  doc.id,
                  docData
                )
              : null;
          });
          return st.items[payload.collection];
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    manage: async (payload) => {
      var itemRef = fbBase.collection(payload.collection);
      
      // Check if user is admin
      const isAdmin = store.state.app.advanced.roles.admin &&
        store.state.app.advanced.roles.admin.members &&
        store.state.app.advanced.roles.admin.members.includes(store.state.auth.uid);
      
      // If admin, get all items from the collection
      if (isAdmin) {
        st.manageData[payload.collection] = {};
        var itemList = {};
        return itemRef
          .get()
          .then(function (querySnapshot) {
            return Promise.all(
              querySnapshot.docs.map(async (doc) => {
                var manData = doc.data();
                if (manData) {
                  itemList[manData.id || doc.id] = manData;
                  Vue.set(
                    st.manageData[payload.collection],
                    manData.id || doc.id,
                    manData
                  );
                }
              })
            ).then(() => {
              return itemList;
            });
          })
          .catch(function (error) {
            console.log("Error getting documents:", error);
          });
      }
      
      // Otherwise, get only user's items
      return fbBase
        .collection("user")
        .doc(st.auth.uid)
        .get()
        .then(function (DocumentSnapshot) {
          var userDoc = DocumentSnapshot.data();
          var itemList = {};
          if (userDoc.items && userDoc.items[payload.collection]) {
            st.manageData[payload.collection] = {};
            return Promise.all(
              userDoc.items[payload.collection].map(async (doc) => {
                return await itemRef
                  .doc(doc)
                  .get()
                  .then(function (docData) {
                    var manData = docData.data();
                    if (manData) {
                      itemList[manData.id] = manData;
                      Vue.set(
                        st.manageData[payload.collection],
                        manData.id,
                        manData
                      );
                      return st.manageData;
                    } else return;
                  });
              })
            ).then(() => {
              return itemList;
            });
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    email: async (payload) => {
      return fbBase
        .collection("user")
        .doc(payload.id)
        .collection("private")
        .doc("content")
        .get()
        .then((doc) => {
          var email = doc.data().email;
          return email;
        });
    },
    event: async (payload) => {
      fbBase
        .collection("relate")
        .doc(payload.type + "s")
        .collection(payload.itemType)
        // .limit(payload.limit || 100)
        .doc(payload.id)
        .onSnapshot(
          {
            // Listen for document metadata changes
            includeMetadataChanges: t,
          },
          function (doc) {
            var returnDoc = doc.data();
            if (store.state.events[payload.itemType]) {
              // TODO Add scheduling system into here

              Vue.set(
                store.state.events[payload.itemType],
                payload.id,
                returnDoc
              );
            } else {
              Vue.set(store.state.events, payload.itemType, {
                [payload.id]: returnDoc,
              });
            }
            return returnDoc;
          }
        );
    },
    job: async (payload) => {
      fbBase
        .collection("relate")
        .doc(payload.type + "s")
        .collection(payload.itemType)
        // .limit(payload.limit || 100)
        .doc(payload.id)
        .onSnapshot(
          {
            // Listen for document metadata changes
            includeMetadataChanges: t,
          },
          function (doc) {
            var returnDoc = doc.data();
            if (store.state.events[payload.itemType]) {
              // TODO Add scheduling system into here

              Vue.set(
                store.state.events[payload.itemType],
                payload.id,
                returnDoc
              );
            } else {
              Vue.set(store.state.events, payload.itemType, {
                [payload.id]: returnDoc,
              });
            }
            return returnDoc;
          }
        );
    },
    maintenance: async () => {
      try {
        const axios = require("axios");
        return axios
          .post(
            "https://us-central1-p3c-prsprty.cloudfunctions.net/maintenance",
            { data: { reload: f, params: "hello", otherAppStuff: "yeah" } }
          )
          .then((data) => {
            return data.data;
          });
      } catch (error) {
        console.log(error);
      }
    },
    orders: async (payload) => {
      if (store.state.counts.ordersin > 19)
        return (store.state.counts.ordersin = f);
      if (!store.state.counts.ordersin) store.state.counts.ordersin = 0;
      store.state.counts.ordersin = store.state.counts.ordersin + 1;
      if (!store.state.user[payload.user] && store.state.counts.ordersin < 20)
        return setTimeout(() => {
          store.dispatch("query", payload);
        }, 50 * store.state.counts.ordersin);
      if (
        store.state.user[payload.user] &&
        store.state.user[payload.user].orders
      ) {
        return store.state.user[payload.user].orders.forEach((order) => {
          return fbBase
            .collection(payload.type)
            .doc(order)
            .onSnapshot(
              {
                // Listen for document metadata changes
                includeMetadataChanges: t,
              },
              function (doc) {
                const specificOrder = doc.data();
                return specificOrder.paid === "NEW"
                  ? (() => {
                      return QR.toDataURL(
                        `${
                          specificOrder.payment.order.currency || "bitcoin"
                        }:${
                          specificOrder.payment.charge[
                            specificOrder.payment.order.currency || "bitcoin"
                          ].wallet
                        }?${
                          specificOrder.payment.order.currency === "ethereum"
                            ? "value"
                            : "amount"
                        }=${
                          specificOrder.payment.charge[
                            specificOrder.payment.order.currency || "bitcoin"
                          ].amount
                        }`
                      );
                    })().then((qr) => {
                      specificOrder.qr = qr;
                      return store.commit("set", {
                        keys: ["orders", doc.id],
                        val: specificOrder,
                      });
                      // Vue.set(store.state.orders, doc.id, specificOrder)
                    })
                  : store.commit("set", {
                      keys: ["orders", doc.id],
                      val: specificOrder,
                    }); //  Vue.set(store.state.orders, doc.id, specificOrder)
              }
            );
        });
        // return store.state.orders
      }
    },
    sales: async (payload) => {
      if (store.state.counts.salesin > 19)
        return (store.state.counts.salesin = f);
      if (!store.state.counts.salesin) store.state.counts.salesin = 0;
      store.state.counts.salesin = store.state.counts.salesin + 1;
      if (!store.state.user[payload.user] && store.state.counts.salesin < 20)
        return setTimeout(() => {
          store.dispatch("query", payload);
        }, 50 * store.state.counts.salesin);
      store.state.user[payload.user] &&
        store.state.user[payload.user].sales &&
        Object.keys(store.state.user[payload.user].sales).forEach((order) => {
          fbBase
            .collection("orders")
            .doc(order)
            .onSnapshot(
              {
                // Listen for document metadata changes
                includeMetadataChanges: t,
              },
              async (doc) => {
                var orderObj = doc.data();
                var orderTotal = 0;
                var completeCheck = [];
                orderObj.items.forEach((item) => {
                  orderTotal =
                    orderTotal +
                    item.qty * item.purchase.cost +
                    item.purchase["shipping and handling"];
                  if (item.status !== "delivered") {
                    completeCheck.push(item.status);
                  }
                });
                Vue.set(store.state.sales, doc.id, orderObj);
                Vue.set(
                  store.state.sales[doc.id],
                  "complete",
                  completeCheck.length === 0
                );
                Vue.set(store.state.sales[doc.id], "paid", orderObj.paid);
                Vue.set(store.state.sales[doc.id], "total", orderTotal);
              }
            );
        });
    },
    secret: async (payload) => {
      // TODO make it a secret
      return fbBase
        .collection(payload.collection)
        .doc(payload.id)
        .get()
        .then((itemData) => {
          st.secretItem = itemData.data();
          return itemData.data();
        });
    }, // TODO setup for items and events
    user: async (payload) => {
      // TODO Holy fuck refactor this entire user system
      if (!payload.id) return f;
      fbBase
        .collection(payload.type)
        .doc(payload.id)
        .get()
        .then(async (userData) => {
          if (!userData.exists) {
            console.error("User not found:", payload.id);
            return;
          }
          let user = userData.data();
          // Get user subscriptions
          st.app.itemTypes
            ? st.app.itemTypes.forEach((itemType) => {
                Object.keys(st.related).forEach((abilityType) => {
                  fbBase
                    .collection(payload.type)
                    .doc(payload.id)
                    .collection("relate")
                    .doc(abilityType)
                    .collection(itemType)
                    .doc("status")
                    .get()
                    .then((relateData) => {
                      if (relateData.exists) {
                        var related = relateData.data();
                        if (st.related[abilityType]) {
                          Vue.set(st.related[abilityType], itemType, related);
                        } else {
                          st.related[abilityType] = {};
                          Vue.set(st.related[abilityType], itemType, related);
                        }
                      }
                    });
                });
              })
            : console.log("user error", payload);
          if (JSON.stringify(user) === JSON.stringify(st.users[payload.id])) {
            return;
          }
          var itemArr = user[payload.collection || payload.type] || [];
          if (user.cart) {
            Object.keys(user.cart).forEach((cart) => {
              st.counts.cart = st.counts.cart + 1;
              if (user.cart[cart] === null) {
                delete user.cart[cart];
              }
            });
          }
          if (payload.id === st.auth.uid) {
            store.dispatch('query', { type: "value", id: st.auth.uid });
            fbBase
              .collection("user")
              .doc(st.auth.uid)
              .onSnapshot(
                {
                  includeMetadataChanges: t,
                },
                (doc) => {
                  let userdata = doc.data();
                  Vue.set(
                    st.user[st.auth.uid],
                    "auctions",
                    userdata.auctions
                  );
                  ["notifications"].forEach((query) => {
                    if (userdata[query]) {
                      store.dispatch('query', {
                        type: query,
                        data: userdata[query],
                      });
                    }
                  });
                }
              );
          }
          // Initialize user.basics if it doesn't exist
          if (!user.basics) {
            user.basics = {};
          }
          user.basics.image = user.basics.image || (state.defaults && state.defaults.userimage) || "https://preview.redd.it/p61ulijkxr751.jpg?width=320&crop=smart&auto=webp&s=342130582bd6c2aadf98b94a936f57bab25ea1aa";
          user.basics.name = user.basics.name || "Anon";
          // Load files for this user (not just authenticated user)
          // First, get files immediately if they don't exist in store
          if (!store.state.users[payload.id] || !store.state.users[payload.id].files) {
            fbusersbase
              .collection(payload.id)
              .doc("files")
              .get()
              .then((doc) => {
                if (doc.exists) {
                  const filesData = doc.data() || {};
                  store.commit("set", {
                    keys: ["user", payload.id, "files"],
                    val: filesData,
                  });
                  store.commit("set", {
                    keys: ["users", payload.id, "files"],
                    val: filesData,
                  });
                }
              });
          }
          // Set up listener for future updates
          user.files = fbusersbase
            .collection(payload.id)
            .doc("files")
            .onSnapshot((x) => {
              const filesData = x.data() || {};
              store.commit("set", {
                keys: ["user", payload.id, "files"],
                val: filesData,
              });
              store.commit("set", {
                keys: ["users", payload.id, "files"],
                val: filesData,
              });
              return filesData;
            });
          user.keys = fbusersbase
            .collection(payload.id)
            .doc("keys")
            .onSnapshot((x) => {
              const keysData = x.data() || {};
              store.commit("set", {
                keys: ["user", payload.id, "keys"],
                val: keysData,
              });
              return keysData;
            });
          user[payload.collection || payload.type] = [];
          if (!itemArr.forEach) {
            itemArr = Object.keys(itemArr);
          }
          if (itemArr.length > 0) {
            itemArr.forEach((item, indexKey) => {
              fbBase
                .collection(payload.collection || payload.type)
                .doc(item)
                .get()
                .then((itemData) => {
                  if (!itemData.exists) {
                    Vue.set(st.users, payload.id, user);
                    Vue.set(st.user, payload.id, user);
                  } else {
                    user[payload.collection || payload.type].push(
                      itemData.id
                    );
                    st.users[payload.collection || payload.type][item] =
                      itemData.data();
                    if (indexKey + 1 === itemArr.length) {
                      Vue.set(st.users, payload.id, user);
                      Vue.set(st.user, payload.id, user);
                    }
                  }
                });
            });
          } else {
            Vue.set(st.users, payload.id, user);
            Vue.set(st.user, payload.id, user);
          }
        });
      st.auth.uid
        ? fbBase
            .collection("user")
            .doc(st.auth.uid)
            .collection("relate")
            .doc("connect")
            .collection("user")
            .doc("status")
            .get()
            .then((relateData) => {
              if (relateData.exists) {
                var related = relateData.data();
                if (st.related["connect"].user) {
                  Vue.set(st.related["connect"], "user", related);
                } else {
                  // st.related['connect'].user = {}
                  Vue.set(st.related["connect"], "user", related);
                }
              } else {
                st.related["connect"].user = {};
              }
            })
        : console.log("Undefined User");
      st.auth.uid
        ? fbBase
            .collection("user")
            .doc(st.auth.uid)
            .collection("private")
            .doc("content")
            .get()
            .then((pvt) => {
              if (pvt.exists) {
                let pvtdata = pvt.data();
                store.commit("set", {
                  keys: ["user", st.auth.uid, "payouts and funding"],
                  val: pvtdata["payouts and funding"] || {},
                });

                // var related = pvtdata.data()
                // if (st.related['connect'].user) {
                //   mu.setState(store.state.related, { prop: 'connect', prop2: 'user', val: related })
                // } else {
                //   // st.related['connect'].user = {}
                //   mu.setState(st.related['connect'], { prop: 'user', val: related })
                // }
              } else {
                st.related["connect"].user = {};
              }
            })
        : console.log("Undefined User");
      return [st.users, st.user];
    },
    comments: async (payload) => {
      // Store listener reference for cleanup
      const listenerRef = fbBase
        .collection(payload.type)
        // .limit(payload.limit || 100)
        .doc(typeof payload.id === "number" ? payload.comment.id : payload.id)
        .onSnapshot(
          {
            // Listen for document metadata changes
            includeMetadataChanges: t,
          },
          function (doc) {
            
            if (doc.exists) {
              const returncomments = doc.data();
              
              Vue.set(store.state.comments, payload.id, returncomments);
              
              // Load user data for all comment authors to ensure their files are available
              const userIds = new Set();
              Object.keys(returncomments || {}).forEach(commentId => {
                const comment = returncomments[commentId];
                if (comment && comment.user) {
                  // Normalize various possible shapes of comment.user -> extract UID string
                  let commentUser = comment.user;
                  if (typeof commentUser === 'object' && commentUser !== null) {
                    // Try common identity fields
                    commentUser = commentUser.uid || commentUser.id || commentUser.u || commentUser[0] || null;
                  }
                  // If still an array, take first element
                  if (Array.isArray(commentUser)) commentUser = commentUser[0] || null;

                  // If we extracted a UID, update the stored comment to normalize later reads
                  if (commentUser && commentUser !== comment.user) {
                    try { returncomments[commentId].user = commentUser; } catch (e) { /* ignore */ }
                  }

                  if (!commentUser) return;

                  // Check if user data exists and has files loaded
                  const userExists = store.state.users[commentUser] || store.state.user[commentUser];
                  const filesExist = (store.state.users[commentUser] && store.state.users[commentUser].files) ||
                                    (store.state.user[commentUser] && store.state.user[commentUser].files);
                  if (!userExists || !filesExist) {
                    userIds.add(commentUser);
                  }
                }
              });
              
              // Query user data for each unique author (this will load their files)
              userIds.forEach(userId => {
                store.dispatch('query', { type: 'user', id: userId });
              });
              
              return returncomments;
            } else {
              // Document not found for this comment ID. Use debug log to reduce noise.
              console.debug("Document does not exist for comment ID:", payload.id);
            }
          }
        );

      // Store listener reference for potential cleanup
      if (!store.state.commentListeners) {
        Vue.set(store.state, "commentListeners", {});
      }
      store.state.commentListeners[payload.id] = listenerRef;

      return store.state.comments[payload.id];
    },
    stopComments: async (payload) => {
      // Stop Firebase listener for specific comment ID
      const assetId = payload.id;
      if (
        store.state.commentListeners &&
        store.state.commentListeners[assetId]
      ) {
        store.state.commentListeners[assetId](); // Call the unsubscribe function
        delete store.state.commentListeners[assetId];

        // Clear comments from state
        Vue.set(store.state.comments, assetId, {});
      }
      return true;
    },
    commentCounts: async (payload) => {
      // Get comment counts without loading full comment data
      const commentId = payload.id;
      return fbBase
        .collection("comments")
        .doc(commentId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data();
            const count = Object.keys(data).length;
            Vue.set(store.state.commentCounts, commentId, count);
            return count;
          }
          return 0;
        });
    },
    msgs: async (payload) => {
      const authUid = store.state.auth.uid;
      if (!authUid) {
        return {};
      }
      const currentUser = store.state.user[authUid];
      if (!currentUser || !currentUser.msgs) {
        await store.dispatch('query', { id: authUid });
      }
      var unseenMessageArr = [];
      payload.data =
        payload.data || (currentUser && currentUser.msgs);
      if (currentUser) {
        currentUser.msgs = currentUser.msgs || {};
      }

      let msgpromise = new Promise((resolve) => {
        return fbBase
          .collection("msgs")
          .where("users", "array-contains", authUid)
          .onSnapshot({ includeMetadataChanges: t }, (docs) => {
            docs.docs.map((doc, doci) => {
              if (doc.exists) {
                var message = doc.data();
                var userNames = [];
                message.users.forEach((userid) => {
                  userNames.push(store.state.ref.name[userid]);
                });
                message.userNames = userNames;
                // store.state.msgs[message.id] = message
                store.commit("set", {
                  keys: ["msgs", message.id],
                  val: message,
                });
                const userMsgs = store.state.user[authUid]?.msgs;
                if (userMsgs && userMsgs[message.id] === "unseen") {
                  unseenMessageArr.push(message.id);
                }
              }
              if (doci === docs.docs.length - 1) {
                Vue.set(store.state, "msgs", store.state.msgs);
                store.commit("set", {
                  keys: ["counts", "messages"],
                  val: unseenMessageArr.length,
                });
                store.commit("set", {
                  keys: ["componentKeys", "message"],
                  val: store.state.componentKeys.message + 1,
                });
                resolve(store.state.msgs);
              }
            });
          });
      });
      return msgpromise.then((x) => x);
    },
    notifications: async (payload) => {
      const currentUser = store.state.user[store.state.auth.uid];
      payload.data =
        payload.data || (currentUser && currentUser.notifications);
      if (payload.data) {
        Object.keys(payload.data).forEach((item) => {
        fbBase
          .collection("notifications")
          .doc(item)
          .onSnapshot(
            {
              includeMetadataChanges: t,
            },
            (doc) => {
              if (doc.exists) {
                var notification = doc.data();
                notification.actions =
                  notification.actions ||
                  store.state.actions[notification.type];
                Vue.set(st.notifications, item, notification);
              }
              var unseen = [];
              Object.keys(st.notifications).forEach((notification) => {
                if (!store.state.notifications[notification].seen) {
                  unseen.push(notification);
                }
              });
              store.state.counts.notifications = unseen.length;
            }
          );
        });
      }
      return st.notifications;
    },
    item: async (payload) => {
      return fbBase
        .collection(payload.collection || payload.type)
        .doc(payload.id)
        .get()
        .then(async (itemData) => {
          if (itemData.exists) {
            var goods = itemData.data();
            !store.state.items[payload.collection]
              ? (store.state.items[payload.collection] = {})
              : null;
            // var updateItem = { items: t, prop: payload.collection || payload.type, prop2: payload.id, val: goods }
            store.commit("set", { keys: ["item"], val: goods });
            store.commit("set", {
              keys: ["items", payload.collection || payload.type, payload.id],
              val: goods,
            });
            // mu.setState(store.state, updateItem)
          }
          fbBase
            .collection("relate")
            .doc(payload.collection || payload.type)
            .collection(payload.id)
            .get()
            .then((snapshot) => {
              if (snapshot.exists) {
                snapshot.forEach((doc) => {
                  var relateData = doc.data();
                  var relateValues = {};
                  Object.keys(relateData).forEach((relateKey) => {
                    relateValues[relateKey] = relateData[relateKey].length;
                  });
                  Vue.set(store.state.relateValues, payload.id, relateValues);
                });
              }
            });
          return goods;
        });
    },
    tags: async (payload) => {
      return fbBase
        .collection("index")
        .doc(payload.collection)
        .get()
        .then(function (querySnapshot) {
          var tagGroup = querySnapshot.data();
          store.state.tags[payload.collection] =
            store.state.tags[payload.collection] || {};
          store.state.tags[payload.collection][payload.tag] =
            store.state.tags[payload.collection][payload.tag] || {};
          tagGroup[payload.type][payload.tag].forEach(function (iitemid) {
            if (
              store.state.items[payload.collection] &&
              store.state.items[payload.collection][iitemid]
            ) {
              store.state.tags[payload.collection][payload.tag][iitemid] =
                store.state.items[payload.collection][iitemid];
            } else {
              fbBase
                .collection(payload.collection)
                .doc(iitemid)
                .get()
                .then((item) => {
                  store.state.tags[payload.collection][payload.tag][iitemid] =
                    item.data();
                });
            }
          });
          Vue.set(
            store.state.tags[payload.collection],
            payload.tag,
            store.state.tags[payload.collection][payload.tag]
          );
          return store.state.tags[payload.collection][payload.tag];
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    value: async (payload) => {
      return fbBase
        .collection("user")
        .doc(store.state.auth.uid)
        .collection(payload.type)
        .get()
        .then((data) => {
          data.docs.forEach((doc) => {
            Vue.set(store.state.value, doc.id, doc.data());
          });
        });
    },
    logs: async () => {
      const logs = await fbBase.collection("logs").get();
      const emails = await fbBase.collection("email").get();
      return {
        webhooks: logs.docs.map((doc) => doc.data()),
        emails: emails.docs.map((doc) => doc.data()),
      };
    },
    refs: async (payload) => {
      const refTypes = payload.refTypes || ["image", "name", "title"];
      const promises = refTypes.map(async (refType) => {
        const snap = await fbBase.collection("ref").doc(refType).get();
        const data = snap.exists ? snap.data() : {};
        Vue.set(store.state.ref, refType, data);
        return { [refType]: data };
      });
      const results = await Promise.all(promises);
      return Object.assign({}, ...results);
    },
  };
  let isSecret = payload.type && payload.type.includes("secret");
  const methodKey = isSecret ? "secret" : payload.type;
  if (methods[methodKey]) {
    return methods[methodKey](payload);
  }
}

